import script from "./LoginLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginLogo.vue?vue&type=script&setup=true&lang=js"

import "./LoginLogo.vue?vue&type=style&index=0&id=24ab1ac6&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ab1ac6"]])

export default __exports__